<template>
  <!-- FOOTER -->
  <div class="w-full">
    <div class="opacity-90 bg-gradient-to-b from-ch-800 to-ch-900">
      <div
        class="flex flex-col px-16 lg:flex-row sm:justify-center sm:items-center xs:justify-center xs:items-center"
      >
        <div class="w-full pt-12 md:w-1/4">
          <div class="flex items-center">
            <svg
              width="82"
              height="39"
              viewBox="0 0 82 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 37C10.9714 37 14.4762 35.723 14.8571 35.0845L29.7143 24.1082M80 30.7746L58.2857 3L29.7143 24.1082M29.7143 8.26761V24.1082"
                stroke="white"
                stroke-width="3"
              />
            </svg>
            <p class="pl-4 text-xl text-white">Chata Luhačovice</p>
          </div>
          <p class="pt-6 pr-10 text-xs text-white">
            Prozkoumejte krásy lázní Luhačovice a&nbsp;přilehlého okolí v útulné
            chatě s obrovskou zahradou.
          </p>
        </div>
        <div class="w-full pt-12 md:w-1/4 lg:pl-6">
          <h2 class="pt-1 text-xl text-white">Kontakty</h2>
          <a
            href="mailto:ubytovani@chata-luhacovice.cz"
            class="pt-6 text-sm text-white hover:underline"
            >ubytovani@chata-luhacovice.cz</a
          >
          <p class="text-sm text-white">+420 605 789 184</p>
        </div>
        <div class="w-full pt-12 md:w-1/4">
          <h2 class="pt-1 pb-6 text-xl text-white">Důležité odkazy</h2>
          <button
            @click="openModal"
            class="block text-sm text-white hover:underline"
          >
            Provozní řád
          </button>
          <Link
            href="/cenik#platba"
            class="block text-sm text-white hover:underline"
            >Informace o platbě</Link
          >
          <Link
            href="/cenik#casyprijezdu"
            class="block text-sm text-white hover:underline"
            >Informace o příjezdu a odjezdu</Link
          >
        </div>
        <div class="w-full pt-12 md:w-1/4">
          <h2 class="pt-1 pb-6 text-xl text-white">Adresa</h2>
          <p class="text-sm text-white">
            Pozlovice - Luhačovice<br />
            Jurkovičova alej 94
          </p>
          <a
            target="_blank"
            class="flex items-center justify-center w-24 mt-2 text-sm bg-white rounded hover:bg-gray-200 text-ch-800"
            href="https://mapy.cz/zakladni?x=17.7715856&y=49.1180473&z=17&source=firm&id=12890256"
          >
            <svg
              class="my-1 mr-1"
              width="12"
              height="25"
              viewBox="0 0 25 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2154 33.314C1.75586 19.3263 0 17.8907 0 12.75C0 5.70835 5.59642 0 12.5 0C19.4036 0 25 5.70835 25 12.75C25 17.8907 23.2441 19.3263 13.7846 33.314C13.1639 34.2287 11.8361 34.2286 11.2154 33.314ZM12.5 18.0625C15.3765 18.0625 17.7083 15.684 17.7083 12.75C17.7083 9.81597 15.3765 7.4375 12.5 7.4375C9.6235 7.4375 7.29167 9.81597 7.29167 12.75C7.29167 15.684 9.6235 18.0625 12.5 18.0625Z"
                fill="currentColor"
              />
            </svg>
            Mapa
          </a>
        </div>
      </div>
      <div class="mx-16 mt-16" style="border-top: 1px solid white"></div>
      <div
        class="flex flex-col items-center py-4 pb-8 mx-16 md:flex-row justify-content-between"
      >
        <div
          class="flex justify-center w-full pt-6 pb-6 mt-2 md:pt-0 md:pb-0 md:justify-end lg:w-1/2"
        >
          <svg
            class="mr-2"
            width="28"
            height="28"
            viewBox="0 0 39 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.5044 9.25728C13.9708 9.25728 9.50747 13.6072 9.50747 19C9.50747 24.3928 13.9708 28.7427 19.5044 28.7427C25.0379 28.7427 29.5012 24.3928 29.5012 19C29.5012 13.6072 25.0379 9.25728 19.5044 9.25728ZM19.5044 25.334C15.9284 25.334 13.0051 22.4935 13.0051 19C13.0051 15.5065 15.9197 12.666 19.5044 12.666C23.089 12.666 26.0036 15.5065 26.0036 19C26.0036 22.4935 23.0803 25.334 19.5044 25.334ZM32.2419 8.85875C32.2419 10.1222 31.1978 11.1312 29.9102 11.1312C28.6138 11.1312 27.5784 10.1137 27.5784 8.85875C27.5784 7.60382 28.6225 6.5863 29.9102 6.5863C31.1978 6.5863 32.2419 7.60382 32.2419 8.85875ZM38.863 11.1651C38.7151 8.12105 38.0016 5.42463 35.7134 3.20306C33.4339 0.981479 30.6671 0.286177 27.5436 0.133549C24.3244 -0.0445163 14.6756 -0.0445163 11.4564 0.133549C8.34161 0.277697 5.57485 0.973 3.28661 3.19458C0.998383 5.41616 0.293642 8.11257 0.137033 11.1566C-0.0456776 14.294 -0.0456776 23.6975 0.137033 26.8349C0.284941 29.8789 0.998383 32.5754 3.28661 34.7969C5.57485 37.0185 8.33291 37.7138 11.4564 37.8665C14.6756 38.0445 24.3244 38.0445 27.5436 37.8665C30.6671 37.7223 33.4339 37.027 35.7134 34.7969C37.9929 32.5754 38.7064 29.8789 38.863 26.8349C39.0457 23.6975 39.0457 14.3025 38.863 11.1651ZM34.7041 30.2012C34.0255 31.8631 32.7117 33.1435 30.9977 33.8133C28.4311 34.8054 22.3407 34.5765 19.5044 34.5765C16.668 34.5765 10.5689 34.7969 8.01099 33.8133C6.30569 33.152 4.99191 31.8716 4.30457 30.2012C3.28661 27.6998 3.52153 21.7643 3.52153 19C3.52153 16.2357 3.29532 10.2918 4.30457 7.79884C4.98321 6.1369 6.29699 4.85652 8.01099 4.18666C10.5776 3.19458 16.668 3.42352 19.5044 3.42352C22.3407 3.42352 28.4398 3.20306 30.9977 4.18666C32.703 4.84804 34.0168 6.12842 34.7041 7.79884C35.7221 10.3002 35.4872 16.2357 35.4872 19C35.4872 21.7643 35.7221 27.7082 34.7041 30.2012Z"
              fill="white"
            />
          </svg>
          <svg
            width="36"
            height="29"
            viewBox="0 0 53 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M51.8925 5.78925C51.283 3.51047 49.487 1.71578 47.2067 1.10672C43.0736 0 26.5 0 26.5 0C26.5 0 9.92652 0 5.79324 1.10672C3.51296 1.71587 1.71703 3.51047 1.10749 5.78925C0 9.91966 0 18.5374 0 18.5374C0 18.5374 0 27.1551 1.10749 31.2855C1.71703 33.5643 3.51296 35.2842 5.79324 35.8933C9.92652 37 26.5 37 26.5 37C26.5 37 43.0735 37 47.2067 35.8933C49.487 35.2842 51.283 33.5643 51.8925 31.2855C53 27.1551 53 18.5374 53 18.5374C53 18.5374 53 9.91966 51.8925 5.78925ZM21.0795 26.3616V10.7131L34.9317 18.5376L21.0795 26.3616Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Link } from "@inertiajs/inertia-vue3";

import { useStore } from "vuex";

const store = useStore();

const openModal = () => {
  store.commit("OPEN_MODAL");
};
</script>
